var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-4 px-8 text-sm lg:text-base"},_vm._l((_vm.collectedCartItems),function(data,index){return _c('KioskOrderItem',_vm._b({key:index,attrs:{"blockUpselling":""}},'KioskOrderItem',Object.assign({}, data,
      {index: index}),false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }